const SubmissionsClosedNotice = () => (
  <p className='bg-gray-100 p-4 text-center text-gray-500 rounded-lg mx-3 mb-3 leading-none'>
    Submissions are closed for this pathway
  </p>
)

export default SubmissionsClosedNotice
